<div class=" mapfre-fs-l-r flex jc-e ai-c">
  <button (click)="dialog.closeAll()" matSuffix mat-icon-button aria-label="Clear">
    <mat-icon class="close-icon">close</mat-icon>
  </button>
</div>
<div class="pr-3 pl-3">
  <h4 class="title">Ninguna póliza de Salud bajo este DNI</h4>
  <p class="description">Necesitas ser un cliente de MAPFRE Salud para acceder al cuadro médico de tu póliza. Por favor,
    vuelve a introducir los datos corectamente. También puedes buscar los médicos y centros sin registrarte.</p>

  <div class="divider2"></div>

  <div class="row mapfre-mb-xsm">
    <app-button class="col mb-4 mb-md-0" type="outline" size="large"
      text="Proceder sin registrar" (click)="openHealthSearch()"></app-button>
    <app-button class="col" size="large" type="primary"
      text="Contratar seguro de salud" (click)="openHirePolicy()"></app-button>
  </div>
  <p class="footer">¿Tienes una duda? Contacta con <a href='#' (click)="openCustomerSupport()">Atención al cliente</a></p>
</div>